import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const PollTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 700,
  marginBottom: theme.spacing(6),
  [theme.breakpoints.up('desktop')]: {
    fontSize: theme.typography.h1.fontSize,
  },
}))

export const ExistingPollsTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 700,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('desktop')]: {
    fontSize: theme.typography.h1.fontSize,
  },
}))

export const PollSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h2.fontSize,
  marginBottom: theme.spacing(3),
  fontWeight: 700,
  [theme.breakpoints.up('desktop')]: {
    fontSize: theme.typography.h1.fontSize,
  },
}))

export const PollSubtitle2 = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  marginBottom: theme.spacing(6),
}))

export const ExisitingPollsSubtitle2 = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  marginBottom: theme.spacing(5),
}))

export const PollCreatedDate = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.colors.neutral.darkGray,
}))

export const PollQuestion = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 700,
}))

export const SinglePollContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
}))

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '16px',
  boxShadow: '6px 0px 20px 0px #0C62FB29;',
  [theme.breakpoints.up('desktop')]: {
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
}))

export const ButtonContainerLive = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'stretch',
  padding: '16px',
  width: '100%',
  boxShadow: '6px 0px 20px 0px #0C62FB29;',
  [theme.breakpoints.up('desktop')]: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%'
  },
}))

export const Button = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '16px',
  boxShadow: '6px 0px 20px 0px #0C62FB29;',
  [theme.breakpoints.up('desktop')]: {
    justifyContent: 'end',
    flexDirection: 'row',
  },
}))

export const PollPushedTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  fontWeight: 700,
  marginBottom: theme.spacing(1),
  color: theme.colors.neutral.darkGray,
}))

export const PushErrorMessage = styled('span')(({theme}) => ({
  color: 'red',
  fontSize: theme.typography.body2.fontSize,
  marginTop: '8px',
  marginLeft: '8px',
}))
